module.exports = __webpack_public_path__ + "img/insight.6bf4edc6.svg";